<template>
    <div class="demo-bed-status" v-if="demoBedIndex > 0">

        <div class="bed-icon"></div>
        <div class="bed-index">
            {{ demoBedIndex }}
        </div>
        <div class="status" :class="connectionStatus"></div>
    </div>
</template>

<script>
import {demobedStore} from "@/stores/demobed";

export default {
    name : "DemoBedStatus",

    data() {
        return {
            bedId: null
        };
    },

    mounted() {
        this.bedId = demobedStore().bedId;
        if (!this.bedId) {
            return this.$router.push({name : "demo-beds"});
        }

        demobedStore().getStatus();
    },

    computed: {
        status() {
            return demobedStore().status;
        },

        demoBedIndex() {
            return this.status.findIndex(x => x.bedId === this.bedId) + 1;
        },

        connectionStatus() {
            return this.status.find(x => x.bedId === this.bedId).status;
        }
    }
};
</script>

<style lang="scss" scoped>
    .demo-bed-status {
        color: #3da032;
        font-size: 2rem;
        font-weight: bold;
        display: flex;
        align-items: center;

        .bed-icon {
            background-image: url('/img/icon-bed-green.svg');
            background-repeat: no-repeat;
            width: 3.75rem;
            height: 2.5rem;
            margin-right : 0.75rem;
            background-size: contain;
        }

        .bed-index {
            margin-right : 0.75rem;
        }

        .status {
            width: 2.25rem;
            height: 2.25rem;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;

            &.offline {
                background-image : url('/img/icon-cocon-disconnected.png');
            }

            &.online {
                background-image : url('/img/icon-cocon-connected.png');
            }
        }
    }
</style>